<app-header navScreen="Home" class="mb-5"></app-header>
<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>

<mat-tab-group class="mt-5 ml-3 pt-4" animationDuration="0ms">
    <mat-tab label="Update Branch IP">
        <div class="title">
            Update Branch IP
        </div>
        <div class="branch-option">
            <mat-radio-group aria-label="Select an option" [(ngModel)]="defaultAll">
                <mat-radio-button *ngFor="let branch of allBranches" class="m-lt" (change)="onBranchChange($event)"
                    [value]="branch.id">{{branch.Value}}</mat-radio-button>
            </mat-radio-group>
        </div>
        <div class="braches-list">
            <app-grid *ngIf="allBranchIPs.length > 0" [type]="gridType" [data]="allBranchIPs" [defaultColumns]="headers"
                [matchedHeaders]="matchedHeaders"></app-grid>
        </div>
    </mat-tab>
    <mat-tab label="Update Work From Home IP" style="height: 550px;">
        <div style="height: 500px;">
            <div class="row update-user-branch-ip">
                <div class="col-md-3">
                    <label class="text-left ka-float-left " for="region">
                        Region </label>
                    <ng-multiselect-dropdown [placeholder]="'Select Region'" [(ngModel)]="selectedRegion"
                        [settings]="multiSelectRegionDropdown" [data]="regionArray"
                        (onSelect)="getSelectedRegion($event)" (onDeSelect)="onRegionDeSelect($event)"
                        (onSelectAll)="onRegionSelectAll($event)" (onDeSelectAll)="onRegionDeSelectAll($event)">
                    </ng-multiselect-dropdown>
                </div>

                <div class="col-md-3">
                    <label class="text-left ka-float-left " for="branch">
                        Branch </label>
                    <ng-multiselect-dropdown [placeholder]="'Select Branch'" [(ngModel)]="selectedBranch"
                        [settings]="multiDropdownSettings" [data]="branchMultiSelectItems"
                        (onSelect)="onBranchItemSelect($event)" (onDeSelect)="onBranchItemDeSelect($event)"
                        (onSelectAll)="onBrachItemsSelectAll($event)" (onDeSelectAll)="onBranchDeSelectAll($event)">
                    </ng-multiselect-dropdown>
                </div>
                <div class="col-md-3">
                    <label class="text-left ka-float-left " for="branch">
                        Employee Name </label>
                    <ng-multiselect-dropdown [placeholder]="'Select Employee Name'" [(ngModel)]="logeedInUser"
                        [settings]="singleSelectionDropdown" class="col-md-5 m-0 p-0" [data]="empNameMultiSelectItems"
                        (onSelect)="onNameItemSelect($event)" (onDeSelect)="onNameItemDeSelect($event)">
                    </ng-multiselect-dropdown>
                </div>
                <div class="col-md-3">
                    <button mdbBtn
                        class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2 m-auto ka-normalButton-height"
                        style="width:auto" mdbWavesEffect type="submit" style="width: 50%;"
                        (click)="getUserBranchIP()">Search</button>
                </div>
            </div>


            <div class="branchDetails-box" *ngIf="branchDetails">
                <hr>
                <form [formGroup]="updateUserBranchForm">
                    <div class="row">
                    <div class="container col-8 ka-updateIp-form" style="margin: 1%">
                        <div class="row">
                            <div class="col-md-12 flexRows">
                                <div class="row inputBox customMultiSelect">
                                    <div class="col-md-12" style="padding-left: 0;">
                                        <p>Start - End Date</p>
                                    </div>
                                    <div class="col-md-6" style="padding-left: 0;">
                                        <input matInput [matDatepicker]="minmaxvalidationDatePicker"
                                            class="form-control ka-disabled" formControlName="startDate"
                                            placeholder="DD/MM/YYYY">
                                        <mat-datepicker-toggle matSuffix [for]="minmaxvalidationDatePicker">
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #minmaxvalidationDatePicker></mat-datepicker>
                                        <div *ngIf="updateUserBranchForm['value']['date']===''" class="error-msg1">
                                            Select Date
                                        </div>
                                    </div>
                                    <div class="col-md-6" style="padding-left: 0;">
                                        <input matInput [matDatepicker]="minmaxDatePicker"
                                            class="form-control ka-disabled" formControlName="endDate"
                                            placeholder="DD/MM/YYYY">
                                        <mat-datepicker-toggle matSuffix [for]="minmaxDatePicker">
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #minmaxDatePicker></mat-datepicker>
                                        <div *ngIf="updateUserBranchForm['value']['date']===''" class="error-msg1">
                                            Select Date
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <!-- <div class="col-md-3 flexRows">
                            <div class="row inputBox customMultiSelect">
                                <div class="col-md-12" style="padding-left: 0;">
                                    <p>Start - End Hours</p>
                                </div>
                                <div class="col-md-6" style="padding-left: 0;">
                                    <select #hoursSelect class="browser-default custom-select" formControlName="startTime">
                                        <option ngValue="">Start Hours</option>
                                        <option *ngFor="let hour of hoursArray" [ngValue]="hour['value']">
                                          <p>{{hour['label']}}</p>
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-6" style="padding-left: 0;">
                                    <select #hoursSelect class="browser-default custom-select" formControlName="endTime">
                                        <option ngValue="">End Hours</option>
                                        <option *ngFor="let hour of hoursArray" [ngValue]="hour['value']">
                                          <p>{{hour['label']}}</p>
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div> -->
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 flexRows">
                                        <div class="row inputBox customMultiSelect">
                                            <div class="col-md-12" style="padding-left: 0;">
                                                <p>IP Address</p>
                                            </div>
                                            <div class="col-md-12" style="padding-left: 0;">
                                                <input type="text" class="form-control" placeholder="IP Address"
                                                    formControlName="macIpAddress" required>
                                                <div class="error-msg"
                                                    *ngIf="updateUserBranchForm.controls.macIpAddress.errors && updateUserBranchForm.controls.macIpAddress.errors.required">
                                                    IP Address Required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 flexRows">
                                        <div class="row inputBox customMultiSelect">
                                            <div class="col-md-12" style="padding-left: 0;">
                                                <p></p>
                                            </div>
                                            <div class="col-md-12" style="padding-left: 0;margin-top: 7%;">
                                                <mat-checkbox formControlName="isActive">Work From Home</mat-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       

                    </div>
                    
                        <div class="col-3 pl-2">
                            <div class="row mt-5">
                            <div class="col-md flexRows mt-5">
                                <div class="col-md-12 mt-3" style="padding-left: 0; display: flex;justify-content: start;">
                                    <button mdbBtn
                                        class="ka-white-button  tButton ka-btn-primary btn-success btn px-5 mb-3 mt-2"
                                        mdbWavesEffect type="submit" [disabled]="updateUserBranchForm.invalid"
                                        (click)="updateWorkFromHomeIP()">Update IP</button>
                                </div>
                            </div>
                        </div>
                        </div>
                    
                    </div>
                </form>
                <hr>
                <div style="display: flex;justify-content: end;padding-right: 25px;" class="col-md-11">
                    <button mdbBtn
                        class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                        mdbWavesEffect type="submit"
                        (click)="redirectToPagePermission(selectedRegion, selectedBranch, logeedInUser)">Employee Permissions</button>
                </div>
                <!-- <div class="emp-btn">
    
                </div> -->
            </div>
        </div>
    </mat-tab>
</mat-tab-group>


<div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="myBasicModalLabel" aria-hidden="true"
    [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">

        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="successModal.hide()">
                <span aria-hidden="true" class="">&times;</span>
            </button>
            <div class="row text-left">

                <!--Grid column-->
                <div class="col-md-12 rmSectionPopup">
                    <div class="row p-2 m-2">

                        <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                            <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
                            <p class="mt-2 p-0">{{responseMessage}} </p>

                            <div class="action-buttons">
                                <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2"
                                    mdbWavesEffect type="submit" (click)="successModal.hide()">ok
                                </button>



                            </div>

                        </div>
                    </div>

                </div>

                <!--Grid column-->



            </div>
        </div>
    </div>
</div>